// Instruction versions on the AI tab (plan chatbot_v2_mono docs/superpowers/plans/2026-10-12-instruction-versions.md).
// No imports on purpose: `node --test` loads this file directly.

export type InstructionVersionAction = 'save' | 'restore' | 'remove' | 'baseline';

/** GET /api/bot-instructions/:system/:botId/versions — one row, no text. */
export interface InstructionVersionSummary {
  id: string;
  action: InstructionVersionAction;
  chars: number;
  actor: string | null;
  restoredFrom: string | null;
  createdAt: string;
}
export interface InstructionVersion extends InstructionVersionSummary {
  content: string | null;
}

export const ACTION_LABEL: Record<InstructionVersionAction, string> = {
  save: 'Saved',
  restore: 'Restored',
  remove: 'Removed',
  baseline: 'Found before a change',
};

const enc = encodeURIComponent;
type Bot = { system: string; botId: string };

export const versionsPath = (bot: Bot): string => `/api/bot-instructions/${bot.system}/${enc(bot.botId)}/versions`;
export const versionPath = (bot: Bot, id: string): string => `${versionsPath(bot)}/${enc(id)}`;
export const restorePath = (bot: Bot, id: string): string => `${versionPath(bot, id)}/restore`;

/** A removal (or a baseline that found nothing) has no text to put back. */
export const canRestore = (v: { action: InstructionVersionAction; chars: number }): boolean => v.action !== 'remove' && v.chars > 0;

export const sizeLabel = (v: { action: InstructionVersionAction; chars: number }): string =>
  v.action === 'remove' || v.chars === 0 ? '—' : `${v.chars} characters`;

export const restoreConfirm = (draftDirty: boolean): string =>
  'Restore this version? It becomes the bot’s instructions now (saved as a new version).' +
  (draftDirty ? ' Your unsaved changes in the editor will be lost.' : '');
